<template>
  <div class="analytics-header">
    <Tabs v-model="activeMainTab" :tabs="mainTabs" />
    <Tabs v-model="activeSubTab" type="card" :tabs="tabs" />
  </div>
</template>

<script>
import Tabs from '@/components/elements/Tabs';
import { AnalyticsType, AnalyticsTypeText } from '@/utils/common';

const MainTabsKey = {
  STATISTICS: 'STATISTICS',
  ANALYTICS: 'ANALYTICS',
};

const MainTabsText = {
  [MainTabsKey.STATISTICS]: 'Статистика',
  [MainTabsKey.ANALYTICS]: 'Аналитика',
};

export default {
  name: 'AnalyticsHeader',
  components: {
    Tabs,
  },
  data: () => ({
    mainTabs: [
      {
        name: MainTabsKey.STATISTICS,
        label: MainTabsText[MainTabsKey.STATISTICS],
      },
      {
        name: MainTabsKey.ANALYTICS,
        label: MainTabsText[MainTabsKey.ANALYTICS],
      },
    ],
    tabs: [
      {
        name: AnalyticsType.OVERVIEW,
        label: AnalyticsTypeText[AnalyticsType.OVERVIEW],
      },
      {
        name: AnalyticsType.ADVANCED,
        label: AnalyticsTypeText[AnalyticsType.ADVANCED],
      },
    ],
    activeSubTab: AnalyticsType.OVERVIEW,
    activeMainTab: MainTabsKey.ANALYTICS,
  }),
  watch: {
    activeMainTab(val) {
      if (val === MainTabsKey.STATISTICS) {
        this.$router.push({ name: 'Home' });
      }
    },
    activeSubTab(val) {
      this.$emit('onChangeSubTab', val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/helpers/variables';
.analytics-header {
  display: flex;
  flex-direction: column;
  gap: 34px;
}
</style>
